"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTextInputWrapper = exports.DisabledWrapperStyles = exports.StyledTextInput = exports.WrapperStyles = exports.InputStyles = exports.StyledTextInputSlot = void 0;
const styled_components_1 = __importStar(require("styled-components"));
/**
 * The problem: JSDOM uses a third-party CSS selector engine called nwsapi,
 * and it doesn't support the :has() selector. This causes Jest tests to fail when parsing styles.
 *
 * The solution: We check if the environment is 'test' and conditionally exclude styles
 * using :has() to ensure Jest can run tests without encountering syntax errors.
 *
 * https://github.com/jsdom/jsdom/issues/3506
 */
const isTestEnv = process.env.NODE_ENV === "test";
exports.StyledTextInputSlot = styled_components_1.default.span `
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: calc(
        var(--ds-text-input-wrapper-height) -
            (2 * var(--ds-text-input-wrapper-border-width))
    );

    --ds-icon-size: 1.5rem;

    &[data-text-input-position="start"] {
        border-start-start-radius: calc(
            var(--ds-border-radius) - var(--ds-text-input-wrapper-border-width)
        );
        border-end-start-radius: calc(
            var(--ds-border-radius) - var(--ds-text-input-wrapper-border-width)
        );
        order: -1;
    }
    &[data-text-input-position="end"] {
        border-start-end-radius: calc(
            var(--ds-border-radius) - var(--ds-text-input-wrapper-border-width)
        );
        border-end-end-radius: calc(
            var(--ds-border-radius) - var(--ds-text-input-wrapper-border-width)
        );
    }
`;
exports.InputStyles = (0, styled_components_1.css) `
    all: unset;
    background-color: transparent;
    border: none;
    outline: none;
    min-width: 0;
    flex-grow: 1;
    box-shadow: none;
    text-align: inherit;
    padding: 0.5rem 0.75rem;

    ${exports.StyledTextInputSlot}[data-text-input-position="start"] ~ & {
        padding-inline-start: 0;
    }

    ${exports.StyledTextInputSlot}[data-text-input-position="end"] ~ & {
        padding-inline-end: 0;
    }

    ${!isTestEnv &&
    (0, styled_components_1.css) `
        &:has(~ ${exports.StyledTextInputSlot}[data-text-input-position="start"]) {
            padding-inline-start: 0;
        }

        &:has(~ ${exports.StyledTextInputSlot}[data-text-input-position="end"]) {
            padding-inline-end: 0;
        }
    `}

    &:hover,
    &:focus,
    &:focus-visible {
        outline: none !important;
        box-shadow: none !important;
    }
    &::placeholder {
        color: var(--ds-color-stone);
    }
`;
exports.WrapperStyles = (0, styled_components_1.css) `
    font-family: var(--ds-font-family);
    display: flex;
    border-radius: var(--ds-border-radius);
    --ds-text-input-wrapper-border-width: 1px;
    border: var(--ds-text-input-wrapper-border-width) solid
        ${({ $isInvalid }) => $isInvalid ? "var(--ds-color-red-100)" : "var(--ds-color-stone)"};
    background-color: var(--ds-color-white);
    align-items: stretch;

    &:hover {
        border-color: ${({ $isInvalid }) => $isInvalid ? "var(--ds-color-red-130)" : "var(--ds-color-metal)"};
    }

    &:focus-within {
        outline: 2px solid var(--ds-color-blue-100);
        outline-offset: 2px;
    }
`;
exports.StyledTextInput = styled_components_1.default.input `
    ${exports.InputStyles}
`;
exports.DisabledWrapperStyles = (0, styled_components_1.css) `
    border-color: var(--ds-color-stone);
    background-color: var(--ds-color-cloud);
    color: var(--ds-color-stone);
`;
exports.StyledTextInputWrapper = styled_components_1.default.div `
    ${exports.WrapperStyles}

    --ds-text-input-wrapper-height: 40px;
    height: var(--ds-text-input-wrapper-height);

    ${!isTestEnv &&
    (0, styled_components_1.css) `
        &:has(${exports.StyledTextInput}:disabled) {
            ${exports.DisabledWrapperStyles}
        }
    `}
`;
//# sourceMappingURL=TextInput.styles.js.map